<template>
    <div class="text-center my-5 justify-content-center">
        <b-spinner class="align-middle" variant="dark"></b-spinner>
        <strong class="ml-3"><slot>{{ $t('utils.loading') }}...</slot></strong>
    </div>
</template>

<script>
    export default {
        name: "BaseSpinner",
    };
</script>